export enum EmailSearchOrder {
  OrderBySentDateTime = 1,
  OrderByStateDateTime = 5,
  OrderByFrom = 2,
  OrderByTo = 3,
  OrderBySeen = 4,
  OrderBySentDateTimeOrStateDateTimeIfSentDateTimeIsNull = 6,
}
